import { RateLimitMonitor } from "../components/RateLimitMonitor";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

export default function RateMonitorPage() {
  return (
    <div className="container py-6 px-6 mx-auto">
      <div className="grid gap-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight mb-2">API Rate Monitoring</h1>
          <p className="text-gray-500">
            Monitor Dataverse API rate limits and current usage
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          <RateLimitMonitor />
          <Card>
            <CardHeader>
              <CardTitle>About Rate Limiting</CardTitle>
              <CardDescription>How the API rate limits work</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4 text-sm">
              <p>
                The Dataverse API is protected by rate limiting to prevent overloading the service.
                This implementation uses a Redis-based token bucket algorithm to manage API requests.
              </p>
              <div>
                <h3 className="font-semibold mb-1">How it works:</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Each API call consumes one or more tokens from the bucket</li>
                  <li>Tokens are automatically replenished at the configured rate</li>
                  <li>If no tokens are available, requests wait or are rejected</li>
                  <li>More complex requests (like those with $expand) use more tokens</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-1">Benefits:</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Prevents API throttling and 429 errors from Dataverse</li>
                  <li>Allows higher priority operations to proceed first</li>
                  <li>Automatically queues requests during high load</li>
                  <li>Provides visibility into API usage patterns</li>
                </ul>
              </div>
              <p className="text-xs text-gray-500 mt-4">
                Rate limits can be configured via environment variables:
                <br />
                <code>DATAVERSE_RATE_LIMIT_PER_SECOND</code> and <code>DATAVERSE_BURST_LIMIT</code>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}